import { Controller } from "stimulus";
import consumer from "../../channels/consumer"
import Rails from "rails-ujs";

export default class extends Controller {
  static targets = ["autosavedNotice"]


  connect() {

     if (!!document.getElementById("edit_article_page")) {
       this.channel = consumer.subscriptions.create({ channel: "AdminUserEditingStatusChannel", article_id: document.getElementById("edit_article_page").dataset.articleId }, {
         connected() {
           // Called when the subscription is ready for use on the server
         },

         disconnected() {
           // Called when the subscription has been terminated by the server
         },

         received(data) {
           // Called when there's incoming data on the websocket for this channel
         }
       });
     }

    setInterval(() => {
      if (document.getElementById("edit_lock_overlay") == null) {
        this.getCurrentEditLockStatus();
      }
    }, 30*1000);


    setInterval(() => {
      // if (document.getElementById("edit_lock_overlay") == null) {
        this.autosave();
      // }
    }, 120*1000) // autosave every 2 minutes
  }

  disconnect() {
    this.channel.unsubscribe()
  }
  
  getCurrentEditLockStatus() {
    fetch(`/admin/articles/${this.element.dataset.articleId}/edit_lock_status`, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "X-CSRF-Token": Rails.csrfToken(),
        }
      })
  }

  autosave() {
    let params = new URLSearchParams(document.location.search)

    // prevent autosave if on history view mode
    if (!!params.get("autosave") || !!params.get("revision")) return;

    var currentLocale = params.get("lang") || "it"
    var articleData = {
      locales_title: JSON.parse(this.element.dataset.localesTitle),
      locales_content: JSON.parse(this.element.dataset.localesContent)
    }

    if (window?.editor == undefined) return;

    articleData["locales_title"][currentLocale] = document.getElementById("article_title_" + currentLocale).value;
    articleData["locales_content"][currentLocale] = window?.editor?.getData();



    fetch(
      `/admin/articles/${this.element.dataset.articleId}/article_autosaves`, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "X-CSRF-Token": Rails.csrfToken(),

        },
        body: JSON.stringify(articleData)
      }).then((response) => {
        if (response.ok) {
          this.autosavedNoticeTarget.classList.remove("hidden")
          this.autosavedNoticeTarget.classList.add("animate__animated", "animate__fadeIn")

          setTimeout(() => {
            this.autosavedNoticeTarget.classList.remove("animate__animated", "animate__fadeOut")

          }, 2000);

          setTimeout(() => {
            this.autosavedNoticeTarget.classList.remove("animate__animated", "animate__fadeIn")
            this.autosavedNoticeTarget.classList.add("hidden")
          }, 4000);


        }
      })
  } 
}


